import * as React from 'react';

import { createIcon } from '../Icon';
export const MonitorIcon = createIcon(
  <React.Fragment>
    <rect height={14} rx={2} ry={2} width={20} x={2} y={3} />
    <line x1={8} x2={16} y1={21} y2={21} />
    <line x1={12} x2={12} y1={17} y2={21} />
  </React.Fragment>,
  'MonitorIcon'
);
